
export default [
    {
        icon: 'home',
        text:'base.home',
        link: { name: "home" },
        galleryHide: true,
        panel: false
    },

    {
        icon: 'engineering',
        text: 'menu.operation',
        permission: 'OPERATION_MENU',
        children: [
            {
                icon: 'storefront',
                text: 'menu.orderBar',
                link: {name: "BarOrderPage"},
                permission: 'ORDER_SHOW_BAR'
            },
            {
                icon: 'manage_history',
                text: 'menu.barOrders',
                link: {name: "OrderFlowPage"},
                permission: 'ORDER_SHOW_BAR'
            },
            {
                icon: 'select_all',
                text: 'menu.barAllOrders',
                link: {name: "OrderFlowAllPage"},
                permission: 'ORDER_SHOW_BAR'
            },
            {
                icon: 'list_alt',
                text: 'menu.orders',
                link: {name: "OrderCrudPage"},
                permission: 'ORDER_SHOW_BAR'
            },
            {
                icon: 'kitchen',
                text: 'menu.kitchenOrders',
                link: {name: "OrderFlowKitchenPage"},
                permission: 'ORDER_SHOW_KITCHEN'
            },
            {
                icon: 'microwave',
                text: 'menu.ovenOrders',
                link: {name: "OrderFlowOvenPage"},
                permission: 'ORDER_SHOW_OVEN'
            },
            {
                icon: 'moped',
                text: 'menu.deliveryOrders',
                link: {name: "OrderFlowDeliveryPage"},
                permission: 'ORDER_SHOW_DELIVERY'
            },
            {
                icon: 'restart_alt',
                text: 'menu.restartOrder',
                link: {name: "OrderResetPage"},
                permission: 'ORDER_SHOW_BAR'
            },
            {
                icon: 'qr_code_2',
                text: 'QR',
                link: {name: "QrPage"},
            },
        ]
    },
    {
        icon: 'inventory',
        text: 'menu.salon',
        permission: 'SALON_MENU',
        children: [
            {
                icon: 'restaurant',
                text: 'menu.salon',
                link: {name: "SalonOrderPage"},
                permission: 'ORDER_SHOW_SALON'
            },
            {
                icon: 'table_chart',
                text: 'menu.salonOrder',
                link: {name: "OrderFlowSalonPage"},
                permission: 'ORDER_SHOW_SALON'
            },
            {
                icon: 'tapas',
                text: 'menu.waiterOrders',
                link: {name: "OrderFlowWaiterPage"},
                permission: 'ORDER_SHOW_WAITER'
            }
        ]
    },
    {
        icon: 'summarize',
        text: 'menu.reports',
        permission: 'REPORT_MENU',
        children: [
            {
                icon: 'poll',
                text: 'menu.salesReport',
                link: {name: "SalesReportPage"},
                permission: 'REPORT_SALES'
            },
            {
                icon: 'account_balance_wallet',
                text: 'menu.orderReport',
                link: {name: "OrderReportPage"},
                permission: 'REPORT_ORDER'
            },
            {
                icon: 'point_of_sale',
                text: 'menu.arqueoReport',
                link: {name: "ArqueoReportPage"},
                permission: 'REPORT_ORDER'
            },
        ]
    },
    {
        icon: 'inventory',
        text: 'menu.stock',
        permission: 'STOCK_MENU',
        children: [
            {
                icon: 'low_priority',
                text: 'menu.stockOperation',
                link: {name: "StockOperationPage"},
                permission: 'STOCK_MENU'
            },
            {
                icon: 'summarize',
                text: 'menu.stockReport',
                link: {name: "StockReportPage"},
                permission: 'STOCK_MENU'
            },
            {
                icon: 'warning',
                text: 'menu.stockTransactionAudit',
                link: {name: "StockTransactionAuditPage"},
                permission: 'STOCK_MENU'
            },
            {
                icon: 'inventory',
                text: 'menu.stock',
                link: {name: "StockPage"},
                permission: 'STOCK_MENU'
            },

        ]
    },

    {
        icon: 'settings',
        text: 'menu.calendars',
        permission: 'MANAGE_MENU',
        children: [
            {
                icon: 'edit_calendar',
                text: 'menu.calendars',
                link: {name: "CalendarManagementPage"},
                permission: 'CALENDAR_UPDATE'
            },
            {
                icon: 'edit_calendar',
                text: 'menu.calendarTakeAway',
                link: {name: "CalendarSchedulePage", params: {identifier: 'take-away'}},
                permission: 'CALENDAR_UPDATE'
            },
            {
                icon: 'edit_calendar',
                text: 'menu.calendarDelivery',
                link: {name: "CalendarSchedulePage", params: {identifier: 'delivery'}},
                permission: 'CALENDAR_UPDATE'
            },
        ]
    },
    {
        icon: 'settings',
        text: 'menu.manage',
        permission: 'MANAGE_MENU',
        children: [
            {
                icon: 'mdi-poll',
                text: 'menu.surveys',
                link: {name: 'SurveysPage'},
                panel: false,
                permission: 'SURVEYS_MANAGEMENT'
            },
            {
                icon: 'mdi-chart-box-multiple-outline',
                text: 'menu.surveyResponses',
                link: {name: 'SurveyResponsesPage'},
                panel: false,
                permission: 'SURVEY_RESPONSES_MANAGEMENT'
            },
            {
                icon: 'shopping_basket',
                text: 'menu.products',
                link: {name: "ProductPage"},
                panel: false,
                permission: 'PRODUCT_CREATE'
            },
            {
                icon: 'category',
                text: 'menu.categories',
                link: {name: "ProductCategoryPage"},
                panel: false,
                permission: 'PRODUCTCATEGORY_CREATE'
            },
            {
                icon: 'shopping_bag',
                text: 'delivery.promo.menu',
                link: {name: "PromoCrudPage"},
                panel: false,
                permission: 'PROMO_MENU'
            },
            {
                icon: 'confirmation_number',
                text: 'delivery.coupon.menu',
                link: {name: "CouponCrudPage"},
                panel: false,
                permission: 'COUPON_MENU'
            },
            {
                icon: 'sticky_note_2',
                text: 'menu.orderState',
                link: {name: "OrderStatePage"},
                panel: false,
                permission: 'ORDERSTATE_CREATE'
            },
            {
                icon: 'colorize',
                text: 'menu.ingredients',
                link: {name: "IngredientPage"},
                panel: false,
                permission: 'INGREDIENT_CREATE'
            },

            {
                icon: 'store',
                text: 'menu.branches',
                link: {name: "BranchPage"},
                panel: false,
                permission: 'BRANCH_CREATE'
            },
            {
                icon: 'paid',
                text: 'menu.paymentMethods',
                link: {name: "PaymentMethodsPage"},
                permission: 'METHOD_SHOW'
            },
            {
                icon: 'settings',
                text: 'menu.settings',
                link: {name: "SettingsPage"},
                permission: 'SETTINGS_SHOW'
            },

        ]
    },
    {
        icon: 'maps',
        text: 'menu.maps',
        permission: 'ZONE_CREATE',
        children: [
            {
                icon: 'satellite',
                text: 'menu.zones',
                link: {name: "ZonePage"},
                permission: 'ZONE_MENU'
            },
/*            {
                icon: 'location_on',
                text: 'menu.locations',
                link: {name: "LocationPage"},
                permission: 'LOCATION_MENU'
            },*/
            {
                icon: 'location_city',
                text: 'menu.localities',
                link: {name: "LocalityPage"},
                permission: 'LOCALITY_MENU'
            },
        ]
    },
    {
        icon: 'person',
        text: 'menu.administration',
        panel: false,
        permission: 'SECURITY_ADMIN_MENU',
        children: [


            {
                icon: 'assignment_ind',
                text: 'user.title',
                link: { name: "userManagement" },
                panel: false,
                permission: 'SECURITY_USER_SHOW'
            },
            {
                icon: 'verified_user',
                text: 'role.title',
                link: { name: "roleManagement" },
                panel: false,
                permission: 'SECURITY_ROLE_SHOW'
            },
            {
                icon: 'group',
                text: 'group.title',
                link: { name: "groupManagement" },
                panel: false,
                permission: 'SECURITY_GROUP_SHOW'
            },
            {
                icon: 'settings_applications',
                text: 'menu.customization',
                link: { name: "customization" },
                panel: false,
                permission: 'CUSTOMIZATION_SHOW'
            },
            {
                icon: 'assignment_ind',
                text: 'menu.userdashboard',
                link: { name: "userDashboard" },
                panel: false,
                permission: 'SECURITY_DASHBOARD_SHOW'
            },

        ]
    },
/*    {
        icon: 'perm_phone_msg',
        text: 'base.about',
        link: { name: "about" },
        panel: false,
    },*/


]
